import { render, staticRenderFns } from "./CompanyNotes.vue?vue&type=template&id=188fcc5e&scoped=true&"
import script from "./CompanyNotes.vue?vue&type=script&lang=js&"
export * from "./CompanyNotes.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotes.vue?vue&type=style&index=0&id=188fcc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188fcc5e",
  null
  
)

export default component.exports